/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Early_Weary_Llama_RoamInputs */

const en_early_weary_llama_roam = /** @type {(inputs: Early_Weary_Llama_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update payment`)
};

const id_early_weary_llama_roam = /** @type {(inputs: Early_Weary_Llama_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perbarui pembayaran`)
};

const ms_early_weary_llama_roam = /** @type {(inputs: Early_Weary_Llama_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kemas kini bayaran`)
};

const ca_early_weary_llama_roam = /** @type {(inputs: Early_Weary_Llama_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualitzar el pagament`)
};

const cs_early_weary_llama_roam = /** @type {(inputs: Early_Weary_Llama_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualizovat platbu`)
};

const da_early_weary_llama_roam = /** @type {(inputs: Early_Weary_Llama_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opdater betaling`)
};

const de_early_weary_llama_roam = /** @type {(inputs: Early_Weary_Llama_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahlung aktualisieren`)
};

const et_early_weary_llama_roam = /** @type {(inputs: Early_Weary_Llama_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uuenda makset`)
};

const es_early_weary_llama_roam = /** @type {(inputs: Early_Weary_Llama_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar método de pago`)
};

const fr_early_weary_llama_roam = /** @type {(inputs: Early_Weary_Llama_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifier le paiement`)
};

const hr_early_weary_llama_roam = /** @type {(inputs: Early_Weary_Llama_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ažuriraj plaćanje`)
};

const it_early_weary_llama_roam = /** @type {(inputs: Early_Weary_Llama_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna pagamento`)
};

const lv_early_weary_llama_roam = /** @type {(inputs: Early_Weary_Llama_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atjaunināt maksājuma informāciju`)
};

const lt_early_weary_llama_roam = /** @type {(inputs: Early_Weary_Llama_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atnaujinti mokėjimo informaciją`)
};

const hu_early_weary_llama_roam = /** @type {(inputs: Early_Weary_Llama_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fizetési adatok frissítése`)
};

const nl_early_weary_llama_roam = /** @type {(inputs: Early_Weary_Llama_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betaalmethode bijwerken`)
};

const nb_early_weary_llama_roam = /** @type {(inputs: Early_Weary_Llama_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endre betalingen`)
};

const pl_early_weary_llama_roam = /** @type {(inputs: Early_Weary_Llama_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaktualizuj dane płatności`)
};

const pt_early_weary_llama_roam = /** @type {(inputs: Early_Weary_Llama_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizar pagamento`)
};

const ro_early_weary_llama_roam = /** @type {(inputs: Early_Weary_Llama_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizează metoda de plată`)
};

const sk_early_weary_llama_roam = /** @type {(inputs: Early_Weary_Llama_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualizovať platbu`)
};

const sl_early_weary_llama_roam = /** @type {(inputs: Early_Weary_Llama_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posodobitev plačila`)
};

const fi_early_weary_llama_roam = /** @type {(inputs: Early_Weary_Llama_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Päivitä maksu`)
};

const sv_early_weary_llama_roam = /** @type {(inputs: Early_Weary_Llama_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uppdatera betalning`)
};

const vi_early_weary_llama_roam = /** @type {(inputs: Early_Weary_Llama_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cập nhật thanh toán`)
};

const tr_early_weary_llama_roam = /** @type {(inputs: Early_Weary_Llama_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ödemeyi güncelle`)
};

const el_early_weary_llama_roam = /** @type {(inputs: Early_Weary_Llama_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ενημέρωση πληρωμής`)
};

const bg_early_weary_llama_roam = /** @type {(inputs: Early_Weary_Llama_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Актуализиране на плащането`)
};

const ru_early_weary_llama_roam = /** @type {(inputs: Early_Weary_Llama_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновить метод оплаты`)
};

const sr_early_weary_llama_roam = /** @type {(inputs: Early_Weary_Llama_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ажурирај плаћање`)
};

const uk_early_weary_llama_roam = /** @type {(inputs: Early_Weary_Llama_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оновити платіжну інформацію`)
};

const ka_early_weary_llama_roam = /** @type {(inputs: Early_Weary_Llama_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`გადახდის განახლება`)
};

const hi_early_weary_llama_roam = /** @type {(inputs: Early_Weary_Llama_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पेमेंट अपडेट करें`)
};

const th_early_weary_llama_roam = /** @type {(inputs: Early_Weary_Llama_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อัปเดตการชำระเงิน`)
};

const ko_early_weary_llama_roam = /** @type {(inputs: Early_Weary_Llama_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`결제 업데이트`)
};

const zh_early_weary_llama_roam = /** @type {(inputs: Early_Weary_Llama_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新付款`)
};

const zh_tw_early_weary_llama_roam = /** @type {(inputs: Early_Weary_Llama_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新付款`)
};

const ja_early_weary_llama_roam = /** @type {(inputs: Early_Weary_Llama_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お支払い情報を更新`)
};

/**
* | output |
* | --- |
* | "Update payment" |
*
* @param {Early_Weary_Llama_RoamInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const early_weary_llama_roam = /** @type {((inputs?: Early_Weary_Llama_RoamInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Early_Weary_Llama_RoamInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_early_weary_llama_roam(inputs)
	if (locale === "ms") return ms_early_weary_llama_roam(inputs)
	if (locale === "ca") return ca_early_weary_llama_roam(inputs)
	if (locale === "cs") return cs_early_weary_llama_roam(inputs)
	if (locale === "da") return da_early_weary_llama_roam(inputs)
	if (locale === "de") return de_early_weary_llama_roam(inputs)
	if (locale === "et") return et_early_weary_llama_roam(inputs)
	if (locale === "es") return es_early_weary_llama_roam(inputs)
	if (locale === "fr") return fr_early_weary_llama_roam(inputs)
	if (locale === "hr") return hr_early_weary_llama_roam(inputs)
	if (locale === "it") return it_early_weary_llama_roam(inputs)
	if (locale === "lv") return lv_early_weary_llama_roam(inputs)
	if (locale === "lt") return lt_early_weary_llama_roam(inputs)
	if (locale === "hu") return hu_early_weary_llama_roam(inputs)
	if (locale === "nl") return nl_early_weary_llama_roam(inputs)
	if (locale === "nb") return nb_early_weary_llama_roam(inputs)
	if (locale === "pl") return pl_early_weary_llama_roam(inputs)
	if (locale === "pt") return pt_early_weary_llama_roam(inputs)
	if (locale === "ro") return ro_early_weary_llama_roam(inputs)
	if (locale === "sk") return sk_early_weary_llama_roam(inputs)
	if (locale === "sl") return sl_early_weary_llama_roam(inputs)
	if (locale === "fi") return fi_early_weary_llama_roam(inputs)
	if (locale === "sv") return sv_early_weary_llama_roam(inputs)
	if (locale === "vi") return vi_early_weary_llama_roam(inputs)
	if (locale === "tr") return tr_early_weary_llama_roam(inputs)
	if (locale === "el") return el_early_weary_llama_roam(inputs)
	if (locale === "bg") return bg_early_weary_llama_roam(inputs)
	if (locale === "ru") return ru_early_weary_llama_roam(inputs)
	if (locale === "sr") return sr_early_weary_llama_roam(inputs)
	if (locale === "uk") return uk_early_weary_llama_roam(inputs)
	if (locale === "ka") return ka_early_weary_llama_roam(inputs)
	if (locale === "hi") return hi_early_weary_llama_roam(inputs)
	if (locale === "th") return th_early_weary_llama_roam(inputs)
	if (locale === "ko") return ko_early_weary_llama_roam(inputs)
	if (locale === "zh") return zh_early_weary_llama_roam(inputs)
	if (locale === "zh-tw") return zh_tw_early_weary_llama_roam(inputs)
	if (locale === "ja") return ja_early_weary_llama_roam(inputs)
	return en_early_weary_llama_roam(inputs)
});